"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var link_1 = __importDefault(require("./sub/link"));
var main_media_1 = __importDefault(require("./sub/main-media"));
var logo_1 = __importDefault(require("./sub/logo"));
var title_1 = __importDefault(require("./sub/title"));
var badge_1 = __importDefault(require("./sub/badge"));
var description_1 = __importStar(require("./sub/description"));
var transparencyButton_1 = __importDefault(require("./sub/transparencyButton"));
var Netboard = function (_a) {
    var adObj = _a.adObj, troika = _a.troika, grid = _a.grid, legacy = _a.legacy, isBap = _a.isBap, vertical = _a.vertical, subvertical = _a.subvertical, deviceType = _a.deviceType;
    if (subvertical === 'flight') {
        return React.createElement(Travel, { adObj: adObj, deviceType: deviceType });
    }
    if (subvertical === 'prepackage') {
        return React.createElement(Prepackage, { adObj: adObj, deviceType: deviceType });
    }
    if (troika) {
        return (React.createElement(TroikaNetboard, { adObj: adObj, grid: grid, isBap: isBap, vertical: vertical }));
    }
    else if (legacy) {
        return React.createElement(LegacyNetboard, { adObj: adObj });
    }
    return React.createElement(SpadenNetboard, { adObj: adObj });
};
var SpadenNetboard = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native;
    return (React.createElement("div", null,
        React.createElement(comment_1.default, { placement: "NewNativeNetboard", adObj: adObj }),
        React.createElement("div", { className: "native-add native-add-markasadd" },
            React.createElement("div", { className: "native-add__wrap" },
                React.createElement(transparencyButton_1.default, { adObj: adObj, className: "ads-transparency-general ads-transparency-netboard" }),
                React.createElement(link_1.default, { adObj: adObj, className: "mod flex align-items-stretch man userhistory licorice unoverflowify" },
                    React.createElement("div", { className: "inner r-pal" },
                        React.createElement("div", { className: "bd" },
                            React.createElement("div", { className: "result-item-image" },
                                React.createElement("div", { className: "format3by2" },
                                    React.createElement(main_media_1.default, { native: native, className: "centered-image" }))),
                            React.createElement("div", { className: "unoverflowify" },
                                React.createElement("div", { className: "d1" },
                                    React.createElement("span", { className: "mrs mtm bg-banana objectstatus valign-middle", style: { whiteSpace: 'normal' } },
                                        "Annonse fra ",
                                        native.sponsoredBy)),
                                React.createElement(title_1.default, { h: 3, native: native, id: "native-add__title", className: "t3 word-break mhn mvs result-item-heading" }),
                                React.createElement(logo_1.default, { native: native, placement: "new-netboard", className: "result-item-logo" })))))))));
};
var LegacyNetboard = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native;
    return (React.createElement("div", null,
        React.createElement(comment_1.default, { placement: "NativeNetboard", adObj: adObj }),
        React.createElement("div", { className: "native-add native-add-markasadd" },
            React.createElement("div", { className: "native-add__wrap" },
                React.createElement(transparencyButton_1.default, { adObj: adObj, className: "ads-transparency-general ads-transparency-netboard" }),
                React.createElement(link_1.default, { adObj: adObj, className: "native-add__media" },
                    React.createElement(main_media_1.default, { native: native, className: "native-add__media__img" }),
                    React.createElement("div", { className: "native-add__media__caption" },
                        React.createElement("div", { className: "native-add__sponsoredBy" },
                            "Annonse fra ",
                            native.sponsoredBy),
                        React.createElement("div", { className: "native-add__title" }, native.title),
                        React.createElement(logo_1.default, { native: native, placement: "netboard", className: "result-item-logo" })))))));
};
var TroikaNetboard = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, grid = _a.grid;
    var isDescriptionEmpty = !(description_1.getDescription(native).length > 0);
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "NewNativeNetboard", adObj: adObj }),
        React.createElement("div", { "aria-owns": "result-item-heading-" + adObj.targetId }),
        React.createElement("div", { className: "ads__unit__img" },
            React.createElement("div", { className: "ads__unit__img__ratio img-format img-format--ratio3by2 img-format--crop-horizontal img-format--centered" },
                React.createElement(main_media_1.default, { native: native, className: "img-format__img" }))),
        React.createElement("div", { className: "ads__unit__content" },
            React.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: isDescriptionEmpty ? 'row' : 'column',
                    height: '80%',
                } },
                React.createElement("h2", { className: "ads__unit__content__title", id: "result-item-heading-" + adObj.targetId },
                    React.createElement(link_1.default, { adObj: adObj, className: "ads__unit__link" },
                        React.createElement(title_1.default, { native: native, className: "u-pt8" }))),
                grid ? (React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: 'flex-end',
                    } },
                    React.createElement(description_1.default, { native: native, className: "ads__unit__content__list u-pr8" }),
                    React.createElement(logo_1.default, { native: native, style: {
                            maxHeight: '48px',
                            maxWidth: '75px',
                            marginBottom: isDescriptionEmpty
                                ? '8px'
                                : undefined,
                        } }))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", { style: {
                            display: 'flex',
                        } },
                        React.createElement(description_1.default, { native: native, className: "u-float-left ads__unit__content__list u-pr8 u-pb8" })),
                    React.createElement(logo_1.default, { native: native, style: {
                            maxHeight: '48px',
                            maxWidth: '75px',
                            marginLeft: 'auto',
                            marginTop: 'auto',
                        } })))),
            React.createElement("div", { className: "ads__unit__content__status u-position-relative u-d1" },
                React.createElement(badge_1.default, { native: native, style: { color: 'rgb(118, 118, 118)' } }),
                React.createElement("div", { className: "u-position-absolute u-right", style: { top: '-5px' } },
                    React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                            filter: '',
                            zIndex: 1,
                            opacity: 0.6,
                        }, placement: "right" }))))));
};
var Travel = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, _b = _a.deviceType, deviceType = _b === void 0 ? 'desktop' : _b;
    var mobile = deviceType === 'mobile';
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "Netboard - Travel", adObj: adObj }),
        React.createElement(link_1.default, { adObj: adObj, style: {
                width: '100%',
                height: mobile ? '100%' : '170px',
                display: 'flex',
                flexDirection: mobile ? 'column' : 'row',
                textAlign: 'left',
                color: '#474445',
                textDecoration: 'none',
                position: 'relative',
            } },
            React.createElement("div", { style: {
                    flex: 3,
                    display: 'flex',
                } },
                React.createElement(main_media_1.default, { native: native, style: {
                        borderRadius: mobile ? '8px' : '8px 0 0 8px',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                    } })),
            React.createElement("div", { style: {
                    backgroundColor: mobile ? '#ffffff' : '#f6f8fb',
                    flex: 4,
                    borderRadius: '0 8px 8px 0',
                    display: 'flex',
                    flexDirection: 'column',
                } },
                React.createElement("div", { style: {
                        padding: mobile ? '8px 0 0 0' : '16px',
                        position: 'relative',
                        fontSize: '12px !important',
                        width: '100%',
                        height: '100%',
                        flexDirection: 'column',
                    } },
                    React.createElement("div", { className: "u-d1", style: {
                            display: 'flex',
                            marginBottom: mobile ? '8px' : '16px',
                            color: '#767676',
                            textAlign: 'center',
                        } },
                        React.createElement("div", { style: {
                                border: '1px solid rgb(195, 204, 217)',
                                width: '55px',
                                marginRight: '8px',
                                borderRadius: '4px',
                            } }, "Annonse"),
                        React.createElement("div", { style: {
                                color: '#0063fb',
                                marginTop: '1px',
                            } }, native.sponsoredBy)),
                    React.createElement("div", { style: {
                            marginRight: '56px',
                            position: mobile ? 'static' : 'relative',
                            top: mobile ? 0 : '50px',
                        } },
                        React.createElement(title_1.default, { native: native, className: "u-b1", style: mobile
                                ? {}
                                : {
                                    position: 'absolute',
                                    bottom: '10px',
                                    marginBottom: 0,
                                } }),
                        React.createElement(description_1.default, { native: native, className: "u-d1", style: mobile
                                ? {}
                                : {
                                    position: 'absolute',
                                    top: '-6px',
                                    paddingTop: 0,
                                    marginBottom: 0,
                                } })),
                    React.createElement("div", { style: {
                            height: '48px',
                            width: '48px',
                            position: 'absolute',
                            right: mobile ? 0 : '16px',
                            bottom: mobile ? 0 : '16px',
                        } },
                        React.createElement(logo_1.default, { native: native, style: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                            } })))),
            React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                    width: '26px',
                    height: '26px',
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    zIndex: 1,
                    borderTopRightRadius: '8px',
                    borderBottomLeftRadius: '13px',
                    backgroundColor: 'rgba(255,255,255,0.45)',
                } }))));
};
var Prepackage = function (_a) {
    var adObj = _a.adObj, native = _a.adObj.native, _b = _a.deviceType, deviceType = _b === void 0 ? 'desktop' : _b;
    var mobile = deviceType === 'mobile';
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "Netboard - Prepackage", adObj: adObj }),
        React.createElement(link_1.default, { adObj: adObj, className: "u-mv8", style: {
                width: '100%',
                height: mobile ? '100%' : '170px',
                display: 'flex',
                flexDirection: mobile ? 'column' : 'row',
                textAlign: 'left',
                color: '#474445',
                textDecoration: 'none',
                position: 'relative',
            } },
            React.createElement("div", { style: {
                    flex: 1.8,
                    display: 'flex',
                    paddingLeft: mobile ? '2px' : '8px',
                    paddingRight: mobile ? '2px' : '16px',
                } },
                React.createElement(main_media_1.default, { native: native, style: {
                        borderRadius: '8px',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                    } })),
            React.createElement("div", { style: {
                    flex: 3,
                    borderRadius: '0 8px 8px 0',
                    display: 'flex',
                    flexDirection: 'column',
                } },
                React.createElement("div", { style: {
                        padding: mobile ? '8px 0 0 0' : '16px',
                        position: 'relative',
                        fontSize: '12px !important',
                        width: '100%',
                        height: '100%',
                        flexDirection: 'column',
                    } },
                    React.createElement("div", { className: "u-d1", style: {
                            display: 'flex',
                            marginBottom: mobile ? '8px' : '16px',
                            color: '#767676',
                            textAlign: 'center',
                        } },
                        React.createElement("div", { style: {
                                border: '1px solid rgb(195, 204, 217)',
                                width: '55px',
                                marginRight: '8px',
                                borderRadius: '4px',
                            } }, "Annonse"),
                        React.createElement("div", { style: {
                                color: '#0063fb',
                                marginTop: '1px',
                            } }, native.sponsoredBy)),
                    React.createElement("div", { style: {
                            marginRight: '56px',
                            position: mobile ? 'static' : 'relative',
                            top: mobile ? 0 : '50px',
                        } },
                        React.createElement(title_1.default, { native: native, className: "u-b1", style: mobile
                                ? {}
                                : {
                                    position: 'absolute',
                                    bottom: '10px',
                                    marginBottom: 0,
                                } }),
                        React.createElement(description_1.default, { native: native, className: "u-d1", style: mobile
                                ? {}
                                : {
                                    position: 'absolute',
                                    top: '-6px',
                                    paddingTop: 0,
                                    marginBottom: 0,
                                } })),
                    React.createElement("div", { style: {
                            height: '48px',
                            width: '48px',
                            position: 'absolute',
                            right: mobile ? 0 : '16px',
                            bottom: mobile ? 0 : '16px',
                        } },
                        React.createElement(logo_1.default, { native: native, style: {
                                maxWidth: '100%',
                                maxHeight: '100%',
                            } })))),
            React.createElement("div", { className: "u-mt32 u-hide-gt768" }),
            React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                    width: '26px',
                    height: '26px',
                    position: 'absolute',
                    right: '0',
                    top: '0',
                    zIndex: 1,
                    borderTopRightRadius: '8px',
                    borderBottomLeftRadius: '13px',
                    backgroundColor: 'rgba(255,255,255,0.45)',
                } }))));
};
exports.default = Netboard;
